module.exports = __webpack_public_path__ + "img/tab-2.96748dc9.png";